export default __webpack_public_path__ + "static/media/JTWT-BNB.15fec970.svg";